export const talleresConfig = {
  'taller-junio': {
    'inicio': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=0&single=true&output=csv',
      nombre: 'Taller de Junio - Home',
      // Puedes agregar más config específica de la sección aquí
    },
    'estadisticas': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=2009144904&single=true&output=csv',
      nombre: 'Estadísticas Globales Taller Junio'
    },
    'estadisticas/globales': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=2009144904&single=true&output=csv',
      nombre: 'Estadísticas Globales Taller Junio'
    },
    'mi-anecdota': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=979039417&single=true&output=csv',
      nombre: 'Taller de Junio - Mi Anécdota',
      useVersioning: true,
      versionConfig: {
        maxVersions: 4,
        versionNames: {
          1: 'Versión Original',
          2: 'Resumen y Reducción',
          3: 'Generar Afiche',
          4: 'Grabar Audio'
        }
      }
    },
    // agenda: { excelUrl: 'URL_AGENDA', ... },
  },
  'taller-agosto': {
    'inicio': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=2027110738&single=true&output=csv',
      nombre: 'Taller de Agosto - Home'
    },
    'mi-ficha': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=1099235185&single=true&output=csv',
      nombre: 'Taller de Agosto - Mi Ficha',
    },
    'estadisticas/globales': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=2009144904&single=true&output=csv',
      nombre: 'Taller de Agosto - Estadísticas',
    },
    'mi-anecdota': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=979039417&single=true&output=csv',
      nombre: 'Taller de Agosto - Mi Anécdota',
      useVersioning: true,
      versionConfig: {
        maxVersions: 4,
        versionNames: {
          1: 'Versión Original',
          2: 'Resumen y Reducción',
          3: 'Generar Afiche',
          4: 'Grabar Audio'
        }
      }
    },
    // agenda: { excelUrl: 'URL_AGENDA', ... },
    // estadisticas: { excelUrl: 'URL_ESTADISTICAS', ... },
  },

  'taller-virtual-14': {
    'inicio': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMccm71E6cg5tW9_p1c5TphbBXpVCWEMs9jQHRdhI5hLMs33jyfOvGR7LzzLeS1MxFueJKeR8nrM44/pub?gid=0&single=true&output=csv',
      nombre: 'Taller de Tamara - Home'
    },
    'mi-ficha': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMccm71E6cg5tW9_p1c5TphbBXpVCWEMs9jQHRdhI5hLMs33jyfOvGR7LzzLeS1MxFueJKeR8nrM44/pub?gid=1099235185&single=true&output=csv',
      nombre: 'Taller de Tamara - Mi Ficha',
    },
    'estadisticas/globales': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMccm71E6cg5tW9_p1c5TphbBXpVCWEMs9jQHRdhI5hLMs33jyfOvGR7LzzLeS1MxFueJKeR8nrM44/pub?gid=2009144904&single=true&output=csv',
      nombre: 'Taller de Tamara - Estadísticas',
    },
    'mi/ensayo': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMccm71E6cg5tW9_p1c5TphbBXpVCWEMs9jQHRdhI5hLMs33jyfOvGR7LzzLeS1MxFueJKeR8nrM44/pub?gid=1497239533&single=true&output=csv',
      nombre: 'Taller de Tamara - Mi tarea',
    },
    // agenda: { excelUrl: 'URL_AGENDA', ... },
    // estadisticas: { excelUrl: 'URL_ESTADISTICAS', ... },
  },

  'taller-virtual-3': {
    'inicio': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR4vZfMlcFS8IAl6vIfUJGT2GvKNbSwo42V31SrygkpeWzcUciqyBR7B2c2KUPAmbTe0GEkUSqQsHty/pub?gid=0&single=true&output=csv',
      nombre: 'Taller de Natalia - Home'
    },
    'mi-ficha': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR4vZfMlcFS8IAl6vIfUJGT2GvKNbSwo42V31SrygkpeWzcUciqyBR7B2c2KUPAmbTe0GEkUSqQsHty/pub?gid=1099235185&single=true&output=csv',
      nombre: 'Taller de Natalia - Mi Ficha',
    },
    'estadisticas/globales': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR4vZfMlcFS8IAl6vIfUJGT2GvKNbSwo42V31SrygkpeWzcUciqyBR7B2c2KUPAmbTe0GEkUSqQsHty/pub?gid=2009144904&single=true&output=csv',
      nombre: 'Taller de Natalia - Estadísticas',
    },
    'mi/ensayo': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR4vZfMlcFS8IAl6vIfUJGT2GvKNbSwo42V31SrygkpeWzcUciqyBR7B2c2KUPAmbTe0GEkUSqQsHty/pub?gid=1497239533&single=true&output=csv',
      nombre: 'Taller de Natalia - Mi tarea',
    },
  },

  'taller-virtual-13': {
    'inicio': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3zHGTVwSloCe2MD47IyGK9KOkbV9ewAouYrbEAJ5Kq2ei3RLsMGe9YDkSSEuWJS3bDLfgquaS2Wes/pub?gid=0&single=true&output=csv',
      nombre: 'Taller de Zambayonny - Home'
    },
    'mi-ficha': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3zHGTVwSloCe2MD47IyGK9KOkbV9ewAouYrbEAJ5Kq2ei3RLsMGe9YDkSSEuWJS3bDLfgquaS2Wes/pub?gid=1099235185&single=true&output=csv',
      nombre: 'Taller de Zambayonny - Mi Ficha',
    },
    'estadisticas/globales': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3zHGTVwSloCe2MD47IyGK9KOkbV9ewAouYrbEAJ5Kq2ei3RLsMGe9YDkSSEuWJS3bDLfgquaS2Wes/pub?gid=2009144904&single=true&output=csv',
      nombre: 'Taller de Zambayonny - Estadísticas',
    },
    'mi/cancion': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3zHGTVwSloCe2MD47IyGK9KOkbV9ewAouYrbEAJ5Kq2ei3RLsMGe9YDkSSEuWJS3bDLfgquaS2Wes/pub?gid=1497239533&single=true&output=csv',
      nombre: 'Taller de Zambayonny - Mi cancion',
    },
  },
  'taller-virtual-6': {
    'inicio': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTcMbSBj5CYgBNqkHy4Bk4Oa6bHwb-b97uSirEwwU4BKqSN3vIjjv-uSlWrHqPU1EfDGvvravRONbAs/pub?gid=0&single=true&output=csv',
      nombre: 'Taller de Santi Siri - Home'
    },
    'mi-ficha': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTcMbSBj5CYgBNqkHy4Bk4Oa6bHwb-b97uSirEwwU4BKqSN3vIjjv-uSlWrHqPU1EfDGvvravRONbAs/pub?gid=1099235185&single=true&output=csv',
      nombre: 'Taller de Santi Siri - Mi Ficha',
    },
    'estadisticas/globales': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTcMbSBj5CYgBNqkHy4Bk4Oa6bHwb-b97uSirEwwU4BKqSN3vIjjv-uSlWrHqPU1EfDGvvravRONbAs/pub?gid=2009144904&single=true&output=csv',
      nombre: 'Taller de Santi Siri - Estadísticas',
    },
    'mi/tarea': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTcMbSBj5CYgBNqkHy4Bk4Oa6bHwb-b97uSirEwwU4BKqSN3vIjjv-uSlWrHqPU1EfDGvvravRONbAs/pub?gid=1497239533&single=true&output=csv',
      nombre: 'Taller de Santi Siri - Mi tarea',
    },
  },
  // 'taller-virtual-14': {
  //   'mi-anecdota': { excelUrl: 'URL', nombre: 'Taller Virtual 14' },
  //   home: { ... },
  //   estadisticas: { ... },
  // },
  // ...otros slugs
  // Configuración para talleres antiguos que migran al sistema de versionado
  'taller-1': {
    'mi-anecdota': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=979039417&single=true&output=csv',
      nombre: 'Taller 1 - Mi Anécdota',
      useVersioning: true, // Indica que usa el sistema de versionado
      versionConfig: {
        maxVersions: 4,
        versionNames: {
          1: 'Versión Original',
          2: 'Resumen y Reducción',
          3: 'Generar Afiche',
          4: 'Grabar Audio'
        }
      }
    }
  },
  'taller-mayo': {
    'mi-anecdota': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=979039417&single=true&output=csv',
      nombre: 'Taller Mayo - Mi Anécdota',
      useVersioning: true,
      versionConfig: {
        maxVersions: 4,
        versionNames: {
          1: 'Versión Original',
          2: 'Resumen y Reducción',
          3: 'Generar Afiche',
          4: 'Grabar Audio'
        }
      }
    }
  },
  'taller-marzo': {
    'mi-anecdota': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=979039417&single=true&output=csv',
      nombre: 'Taller Marzo - Mi Anécdota',
      useVersioning: true,
      versionConfig: {
        maxVersions: 4,
        versionNames: {
          1: 'Versión Original',
          2: 'Resumen y Reducción',
          3: 'Generar Afiche',
          4: 'Grabar Audio'
        }
      }
    }
  },
  'taller-2': {
    'mi-anecdota': {
      excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=979039417&single=true&output=csv',
      nombre: 'Taller 2 - Mi Anécdota',
      useVersioning: true,
      versionConfig: {
        maxVersions: 4,
        versionNames: {
          1: 'Versión Original',
          2: 'Resumen y Reducción',
          3: 'Generar Afiche',
          4: 'Grabar Audio'
        }
      }
    }
  },

};

export function getTallerSectionConfig(slug, section) {
  return talleresConfig[slug]?.[section] || null;
}

export function getExcelUrl(slug, section) {
  return talleresConfig[slug]?.[section]?.excelUrl || null;
}

// Configuración específica para la vista de docentes
export const docentesConfig = {
  'taller-junio': {
    excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=667422441&single=true&output=csv',
    nombre: 'Taller de Junio - Vista Docente',
    // Columnas específicas para docentes
    columns: {
      TITULO: 'TITULO',
      COPETE: 'COPETE',
      DOCENTE: 'DOCENTE',
      'CANTIDAD CLASES': 'CANTIDAD CLASES',
      'DURACIÓN CLASE (HORAS)': 'DURACIÓN CLASE (HORAS)',
      PRIMERA_CLASE: 'PRIMERA_CLASE',
      HORA: 'HORA',
      ZONA_HORARIA: 'ZONA_HORARIA',
      'INFO CANT 1': 'INFO CANT 1',
      'INFO CANT 2': 'INFO CANT 2',
      'INFO CANT 3': 'INFO CANT 3',
      'TITULO CLASES': 'TITULO CLASES',
      'TITULO DESARROLLO': 'TITULO DESARROLLO',
      'TITULO NOTIFICACIONES': 'TITULO NOTIFICACIONES',
      'INFO NOTIFICACIONES': 'INFO NOTIFICACIONES',
      'TITULO DATOS': 'TITULO DATOS',
      'BOTON ANECDOTA': 'BOTON ANECDOTA',
      'BOTON FICHA': 'BOTON FICHA',
      'TITULO FAQ': 'TITULO FAQ',
      'RESPUESTA FAQ 1': 'RESPUESTA FAQ 1',
      'TITULO FAQ 1': 'TITULO FAQ 1',
      'RESPUESTA FAQ 2': 'RESPUESTA FAQ 2',
      'TITULO FAQ 2': 'TITULO FAQ 2',
      'RESPUESTA FAQ 3': 'RESPUESTA FAQ 3',
      'TITULO FAQ 3': 'TITULO FAQ 3',
      'RESPUESTA FAQ 4': 'RESPUESTA FAQ 4',
      'TITULO FAQ 4': 'TITULO FAQ 4',
      TWITTER: 'TWITTER',
      INSTAGRAM: 'INSTAGRAM',
      // Columnas adicionales específicas para docentes
      'INFO DOCENTE': 'INFO DOCENTE',
      'REDES SOCIALES': 'REDES SOCIALES',
      'ESTADISTICAS DOCENTE': 'ESTADISTICAS DOCENTE',
      // Columna específica para tarjetas dinámicas de docentes
      'TARJETAS DINAMICAS': 'TARJETAS DINAMICAS'
    }
  },
  'taller-agosto': {
    excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPrIyFeHVpt9Se-a185eOU7CpMhng_wjTPdFeYotPLHQTfIPM09gL-GvENTkG30Y0D-0aMlvnho3pi/pub?gid=885172771&single=true&output=csv',
    nombre: 'Taller de Agosto - Vista Docente',
    columns: {
      // Mismo mapeo de columnas que taller-junio
      TITULO: 'TITULO',
      COPETE: 'COPETE',
      DOCENTE: 'DOCENTE',
      'CANTIDAD CLASES': 'CANTIDAD CLASES',
      'DURACIÓN CLASE (HORAS)': 'DURACIÓN CLASE (HORAS)',
      PRIMERA_CLASE: 'PRIMERA_CLASE',
      HORA: 'HORA',
      ZONA_HORARIA: 'ZONA_HORARIA',
      'INFO CANT 1': 'INFO CANT 1',
      'INFO CANT 2': 'INFO CANT 2',
      'INFO CANT 3': 'INFO CANT 3',
      'TITULO CLASES': 'TITULO CLASES',
      'TITULO DESARROLLO': 'TITULO DESARROLLO',
      'TITULO NOTIFICACIONES': 'TITULO NOTIFICACIONES',
      'INFO NOTIFICACIONES': 'INFO NOTIFICACIONES',
      'TITULO DATOS': 'TITULO DATOS',
      'BOTON ANECDOTA': 'BOTON ANECDOTA',
      'BOTON FICHA': 'BOTON FICHA',
      'TITULO FAQ': 'TITULO FAQ',
      'RESPUESTA FAQ 1': 'RESPUESTA FAQ 1',
      'TITULO FAQ 1': 'TITULO FAQ 1',
      'RESPUESTA FAQ 2': 'RESPUESTA FAQ 2',
      'TITULO FAQ 2': 'TITULO FAQ 2',
      'RESPUESTA FAQ 3': 'RESPUESTA FAQ 3',
      'TITULO FAQ 3': 'TITULO FAQ 3',
      'RESPUESTA FAQ 4': 'RESPUESTA FAQ 4',
      'TITULO FAQ 4': 'TITULO FAQ 4',
      TWITTER: 'TWITTER',
      INSTAGRAM: 'INSTAGRAM',
      'INFO DOCENTE': 'INFO DOCENTE',
      'REDES SOCIALES': 'REDES SOCIALES',
      'ESTADISTICAS DOCENTE': 'ESTADISTICAS DOCENTE',
      // Columna específica para tarjetas dinámicas de docentes
      'TARJETAS DINAMICAS': 'TARJETAS DINAMICAS'
    }
  },
  'taller-virtual-14': {
    excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMccm71E6cg5tW9_p1c5TphbBXpVCWEMs9jQHRdhI5hLMs33jyfOvGR7LzzLeS1MxFueJKeR8nrM44/pub?gid=667422441&single=true&output=csv',
    nombre: 'Taller de Tamara - Vista Docente',
    columns: {
      // Mismo mapeo de columnas que taller-junio
      TITULO: 'TITULO',
      COPETE: 'COPETE',
      DOCENTE: 'DOCENTE',
      'CANTIDAD CLASES': 'CANTIDAD CLASES',
      'DURACIÓN CLASE (HORAS)': 'DURACIÓN CLASE (HORAS)',
      PRIMERA_CLASE: 'PRIMERA_CLASE',
      HORA: 'HORA',
      ZONA_HORARIA: 'ZONA_HORARIA',
      'INFO CANT 1': 'INFO CANT 1',
      'INFO CANT 2': 'INFO CANT 2',
      'INFO CANT 3': 'INFO CANT 3',
      'TITULO CLASES': 'TITULO CLASES',
      'TITULO DESARROLLO': 'TITULO DESARROLLO',
      'TITULO NOTIFICACIONES': 'TITULO NOTIFICACIONES',
      'INFO NOTIFICACIONES': 'INFO NOTIFICACIONES',
      'TITULO DATOS': 'TITULO DATOS',
      'BOTON ANECDOTA': 'BOTON ANECDOTA',
      'BOTON FICHA': 'BOTON FICHA',
      'TITULO FAQ': 'TITULO FAQ',
      'RESPUESTA FAQ 1': 'RESPUESTA FAQ 1',
      'TITULO FAQ 1': 'TITULO FAQ 1',
      'RESPUESTA FAQ 2': 'RESPUESTA FAQ 2',
      'TITULO FAQ 2': 'TITULO FAQ 2',
      'RESPUESTA FAQ 3': 'RESPUESTA FAQ 3',
      'TITULO FAQ 3': 'TITULO FAQ 3',
      'RESPUESTA FAQ 4': 'RESPUESTA FAQ 4',
      'TITULO FAQ 4': 'TITULO FAQ 4',
      TWITTER: 'TWITTER',
      INSTAGRAM: 'INSTAGRAM',
      'INFO DOCENTE': 'INFO DOCENTE',
      'REDES SOCIALES': 'REDES SOCIALES',
      'ESTADISTICAS DOCENTE': 'ESTADISTICAS DOCENTE',
      // Columna específica para tarjetas dinámicas de docentes
      'TARJETAS DINAMICAS': 'TARJETAS DINAMICAS'
    }
  },
  'taller-virtual-3': {
    excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR4vZfMlcFS8IAl6vIfUJGT2GvKNbSwo42V31SrygkpeWzcUciqyBR7B2c2KUPAmbTe0GEkUSqQsHty/pub?gid=667422441&single=true&output=csv',
    nombre: 'Taller de Natalia - Vista Docente',
    columns: {
      // Mismo mapeo de columnas que taller-junio
      TITULO: 'TITULO',
      COPETE: 'COPETE',
      DOCENTE: 'DOCENTE',
      'CANTIDAD CLASES': 'CANTIDAD CLASES',
      'DURACIÓN CLASE (HORAS)': 'DURACIÓN CLASE (HORAS)',
      PRIMERA_CLASE: 'PRIMERA_CLASE',
      HORA: 'HORA',
      ZONA_HORARIA: 'ZONA_HORARIA',
      'INFO CANT 1': 'INFO CANT 1',
      'INFO CANT 2': 'INFO CANT 2',
      'INFO CANT 3': 'INFO CANT 3',
      'TITULO CLASES': 'TITULO CLASES',
      'TITULO DESARROLLO': 'TITULO DESARROLLO',
      'TITULO NOTIFICACIONES': 'TITULO NOTIFICACIONES',
      'INFO NOTIFICACIONES': 'INFO NOTIFICACIONES',
      'TITULO DATOS': 'TITULO DATOS',
      'BOTON ANECDOTA': 'BOTON ANECDOTA',
      'BOTON FICHA': 'BOTON FICHA',
      'TITULO FAQ': 'TITULO FAQ',
      'RESPUESTA FAQ 1': 'RESPUESTA FAQ 1',
      'TITULO FAQ 1': 'TITULO FAQ 1',
      'RESPUESTA FAQ 2': 'RESPUESTA FAQ 2',
      'TITULO FAQ 2': 'TITULO FAQ 2',
      'RESPUESTA FAQ 3': 'RESPUESTA FAQ 3',
      'TITULO FAQ 3': 'TITULO FAQ 3',
      'RESPUESTA FAQ 4': 'RESPUESTA FAQ 4',
      'TITULO FAQ 4': 'TITULO FAQ 4',
      TWITTER: 'TWITTER',
      INSTAGRAM: 'INSTAGRAM',
      'INFO DOCENTE': 'INFO DOCENTE',
      'REDES SOCIALES': 'REDES SOCIALES',
      'ESTADISTICAS DOCENTE': 'ESTADISTICAS DOCENTE',
      // Columna específica para tarjetas dinámicas de docentes
      'TARJETAS DINAMICAS': 'TARJETAS DINAMICAS'
    }
  },
  'taller-virtual-13': {
    excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3zHGTVwSloCe2MD47IyGK9KOkbV9ewAouYrbEAJ5Kq2ei3RLsMGe9YDkSSEuWJS3bDLfgquaS2Wes/pub?gid=667422441&single=true&output=csv',
    nombre: 'Taller de Zambayonni - Vista Docente',
    columns: {
      // Mismo mapeo de columnas que taller-junio
      TITULO: 'TITULO',
      COPETE: 'COPETE',
      DOCENTE: 'DOCENTE',
      'CANTIDAD CLASES': 'CANTIDAD CLASES',
      'DURACIÓN CLASE (HORAS)': 'DURACIÓN CLASE (HORAS)',
      PRIMERA_CLASE: 'PRIMERA_CLASE',
      HORA: 'HORA',
      ZONA_HORARIA: 'ZONA_HORARIA',
      'INFO CANT 1': 'INFO CANT 1',
      'INFO CANT 2': 'INFO CANT 2',
      'INFO CANT 3': 'INFO CANT 3',
      'TITULO CLASES': 'TITULO CLASES',
      'TITULO DESARROLLO': 'TITULO DESARROLLO',
      'TITULO NOTIFICACIONES': 'TITULO NOTIFICACIONES',
      'INFO NOTIFICACIONES': 'INFO NOTIFICACIONES',
      'TITULO DATOS': 'TITULO DATOS',
      'BOTON ANECDOTA': 'BOTON ANECDOTA',
      'BOTON FICHA': 'BOTON FICHA',
      'TITULO FAQ': 'TITULO FAQ',
      'RESPUESTA FAQ 1': 'RESPUESTA FAQ 1',
      'TITULO FAQ 1': 'TITULO FAQ 1',
      'RESPUESTA FAQ 2': 'RESPUESTA FAQ 2',
      'TITULO FAQ 2': 'TITULO FAQ 2',
      'RESPUESTA FAQ 3': 'RESPUESTA FAQ 3',
      'TITULO FAQ 3': 'TITULO FAQ 3',
      'RESPUESTA FAQ 4': 'RESPUESTA FAQ 4',
      'TITULO FAQ 4': 'TITULO FAQ 4',
      TWITTER: 'TWITTER',
      INSTAGRAM: 'INSTAGRAM',
      'INFO DOCENTE': 'INFO DOCENTE',
      'REDES SOCIALES': 'REDES SOCIALES',
      'ESTADISTICAS DOCENTE': 'ESTADISTICAS DOCENTE',
      // Columna específica para tarjetas dinámicas de docentes
      'TARJETAS DINAMICAS': 'TARJETAS DINAMICAS'
    }
  },
  'taller-virtual-6': {
    excelUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTcMbSBj5CYgBNqkHy4Bk4Oa6bHwb-b97uSirEwwU4BKqSN3vIjjv-uSlWrHqPU1EfDGvvravRONbAs/pub?gid=667422441&single=true&output=csv',
    nombre: 'Taller de Santi Siri - Vista Docente',
    columns: {
      // Mismo mapeo de columnas que taller-junio
      TITULO: 'TITULO',
      COPETE: 'COPETE',
      DOCENTE: 'DOCENTE',
      'CANTIDAD CLASES': 'CANTIDAD CLASES',
      'DURACIÓN CLASE (HORAS)': 'DURACIÓN CLASE (HORAS)',
      PRIMERA_CLASE: 'PRIMERA_CLASE',
      HORA: 'HORA',
      ZONA_HORARIA: 'ZONA_HORARIA',
      'INFO CANT 1': 'INFO CANT 1',
      'INFO CANT 2': 'INFO CANT 2',
      'INFO CANT 3': 'INFO CANT 3',
      'TITULO CLASES': 'TITULO CLASES',
      'TITULO DESARROLLO': 'TITULO DESARROLLO',
      'TITULO NOTIFICACIONES': 'TITULO NOTIFICACIONES',
      'INFO NOTIFICACIONES': 'INFO NOTIFICACIONES',
      'TITULO DATOS': 'TITULO DATOS',
      'BOTON ANECDOTA': 'BOTON ANECDOTA',
      'BOTON FICHA': 'BOTON FICHA',
      'TITULO FAQ': 'TITULO FAQ',
      'RESPUESTA FAQ 1': 'RESPUESTA FAQ 1',
      'TITULO FAQ 1': 'TITULO FAQ 1',
      'RESPUESTA FAQ 2': 'RESPUESTA FAQ 2',
      'TITULO FAQ 2': 'TITULO FAQ 2',
      'RESPUESTA FAQ 3': 'RESPUESTA FAQ 3',
      'TITULO FAQ 3': 'TITULO FAQ 3',
      'RESPUESTA FAQ 4': 'RESPUESTA FAQ 4',
      'TITULO FAQ 4': 'TITULO FAQ 4',
      TWITTER: 'TWITTER',
      INSTAGRAM: 'INSTAGRAM',
      'INFO DOCENTE': 'INFO DOCENTE',
      'REDES SOCIALES': 'REDES SOCIALES',
      'ESTADISTICAS DOCENTE': 'ESTADISTICAS DOCENTE',
      // Columna específica para tarjetas dinámicas de docentes
      'TARJETAS DINAMICAS': 'TARJETAS DINAMICAS'
    }
  }
  // Se pueden agregar más talleres aquí
};

// Función para obtener la configuración específica de un taller para docentes
export function getDocenteConfig(slug) {
  return docentesConfig[slug] || null;
}

// Función para obtener la URL del Excel de un taller para docentes
export function getDocenteExcelUrl(slug) {
  return docentesConfig[slug]?.excelUrl || null;
}
